import './App.css';
import Home from './Pages/Home/Home';

function App() {
  return (
    <div className='app scroll-smooth'>
      <Home/>
    </div>
  );
}

export default App;
